'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseProduct = exports.getPurchaseFormValues = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _utmValues = require('helpers/utmValues');

var _Validator = require('components/PaymentForm/Validator');

var _bound = require('redux/saga/entities/bound');

var _multitrack = require('helpers/multitrack');

var _deep = require('helpers/deep');

var _forms = require('helpers/forms');

var _optimizely = require('helpers/optimizely');

var _GoogleAnalytics = require('components/GoogleAnalytics/GoogleAnalytics');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _selectors = require('redux/saga/selectors');

var _cart = require('redux/modules/cart');

var _StripeElementsPaymentForm = require('components/PaymentForm/StripeElementsPaymentForm');

var _ApiError = require('components/Errors/ApiError');

var _helpers = require('redux/saga/helpers');

var _msas = require('constants/msas');

var _BaseSignupValidator = require('./BaseSignupValidator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPurchaseFormValues = exports.getPurchaseFormValues = (0, _forms.getFormValues)('purchase');

// This object maps between field on the purchase result and GTM data layer variables
var GTM_RESULT_MAPPING = {
  purchaseChargeAmount: 'charge_amount',
  currency: 'currency_code',
  giftRedemption: 'gift_redemption',
  msaId: 'msa_id',
  msaOfferId: 'msa_offer_id',
  planCode: 'plan_code',
  purchasePlanId: 'plan_id',
  planTierName: 'plan_tier_name',
  purchasePlanPrice: 'plan_price',
  taxAmount: 'tax_amount',
  purchaseTransactionId: 'id',
  offerName: 'offer_name',
  offerId: 'offer_id',
  promotionAlias: 'promotion_alias',
  purchasePromotionId: 'promotion_id',
  transactionId: 'id',
  transactionTotal: 'charge_amount',
  price: 'charge_amount',
  name: 'plan_code',
  sku: 'plan_id'
};

var BaseProduct = exports.BaseProduct = function () {
  function BaseProduct() {
    (0, _classCallCheck3.default)(this, BaseProduct);
  }

  (0, _createClass3.default)(BaseProduct, null, [{
    key: 'postPurchase',
    value: /*#__PURE__*/_regenerator2.default.mark(function postPurchase(result) {
      return _regenerator2.default.wrap(function postPurchase$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _effects.call)(BaseProduct.trackPurchaseSuccess, result);

            case 2:
              _context.next = 4;
              return (0, _effects.call)(_reduxSaga.delay, 750);

            case 4:
              _context.next = 6;
              return (0, _effects.call)(_helpers.gtmSafeRedirect, '/welcome/refer');

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, postPurchase, this);
    })
  }, {
    key: 'submitPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function submitPurchaseData(client, currentUserId, _ref, consents) {
      var stripeTokenPromiseKey = _ref.stripeTokenPromiseKey,
          formData = (0, _objectWithoutProperties3.default)(_ref, ['stripeTokenPromiseKey']);

      var _ref2, _ref3, stripePromiseToCall, activeLocation, cart, payload, _ref4, msaOfferId, msaOffer, errorCode;

      return _regenerator2.default.wrap(function submitPurchaseData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _effects.all)([(0, _effects.call)(_StripeElementsPaymentForm.getTokenPromise, stripeTokenPromiseKey), (0, _effects.call)(_helpers.getUserLocation, client), (0, _effects.select)(_cart.selectCart)]);

            case 2:
              _ref2 = _context2.sent;
              _ref3 = (0, _slicedToArray3.default)(_ref2, 3);
              stripePromiseToCall = _ref3[0];
              activeLocation = _ref3[1];
              cart = _ref3[2];
              _context2.t0 = _extends3.default;
              _context2.t1 = {
                address: {
                  country: formData.countryCode,
                  postal_code: formData.ccZip && String(formData.ccZip)
                }
              };
              _context2.t2 = consents;
              _context2.next = 12;
              return (0, _effects.call)(_utmValues.getForApi);

            case 12:
              _context2.t3 = _context2.sent;
              _context2.next = 15;
              return (0, _effects.call)(stripePromiseToCall);

            case 15:
              _context2.t4 = _context2.sent;
              _context2.t5 = {
                billing_info: _context2.t1,
                consents: _context2.t2,
                conversion: _context2.t3,
                payment_token: _context2.t4
              };
              _context2.t6 = activeLocation && { gls_location_id: (0, _deep.deepExtract)('location.id', activeLocation) };
              _context2.t7 = formData.friendbuyCode && { friendbuy_referral_code: formData.friendbuyCode };
              _context2.t8 = formData.giftCode && { redemption_code: formData.giftCode };
              _context2.t9 = formData.promoCode && { promotion_code: formData.promoCode };
              _context2.t10 = !formData.livePlanId && cart.taxMethod === _cart.TAX_METHOD_TAXSERVICE ? { use_tax_service: true } : {};
              _context2.t11 = formData.livePlanId && {
                digital_plan_id: formData.livePlanId,
                digital_plan_assets: formData.assets || []
              };
              _context2.t12 = formData.msaOfferId ? {
                msa_offer_id: parseInt(formData.msaOfferId, 10)
              } : {
                plan_id: parseInt(formData.planId, 10),
                msa_id: parseInt(formData.msaId, 10)
              };
              _context2.t13 = formData.corporateDetails && formData.corporateDetails.partner && {
                corporate: (0, _defineProperty3.default)({}, formData.corporateDetails.partner, {
                  user_token: formData.corporateDetails.token,
                  initial_url: formData.corporateDetails.initial_url
                })
              };
              payload = (0, _context2.t0)(_context2.t5, _context2.t6, _context2.t7, _context2.t8, _context2.t9, _context2.t10, _context2.t11, _context2.t12, _context2.t13);
              _context2.prev = 26;
              _context2.next = 29;
              return (0, _effects.call)(client.subscription.create, currentUserId, payload);

            case 29:
              return _context2.abrupt('return', _context2.sent);

            case 32:
              _context2.prev = 32;
              _context2.t14 = _context2['catch'](26);
              _context2.next = 36;
              return (0, _effects.select)(getPurchaseFormValues);

            case 36:
              _ref4 = _context2.sent;
              msaOfferId = _ref4.msaOfferId;
              _context2.next = 40;
              return (0, _effects.select)(_bound.msaOfferById.data, msaOfferId);

            case 40:
              msaOffer = _context2.sent;
              errorCode = _context2.t14 && _context2.t14.code ? _context2.t14.code : 'Unknown error code';
              _context2.next = 44;
              return (0, _effects.all)([(0, _effects.call)(_multitrack.ec, 'Membership Purchase Errors', {
                details: _context2.t14 && _context2.t14.details ? _context2.t14.details : 'Unknown error details',
                message: _context2.t14 && _context2.t14.messages ? _context2.t14.messages : 'Unknown error messages',
                code: errorCode,
                user_id: currentUserId,
                plan_id: formData.planId,
                msa_id: formData.msaId,
                promotion_alias: msaOffer && msaOffer.promotion_alias
              }), (0, _effects.call)(_GoogleTagManager.trackGoogleTagManagerEvent, {
                event: 'gaEvent',
                eventCategory: 'Purchase',
                eventAction: 'Membership Purchase Errors',
                eventLabel: formData.planId + ',' + errorCode + '-' + _context2.t14.message,
                eventNI: true
              })]);

            case 44:
              throw _context2.t14;

            case 45:
            case 'end':
              return _context2.stop();
          }
        }
      }, submitPurchaseData, this, [[26, 32]]);
    })

    /* eslint-disable no-unused-vars, no-empty-function */

  }, {
    key: 'trackPurchaseFailure',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseFailure() {
      return _regenerator2.default.wrap(function trackPurchaseFailure$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case 'end':
              return _context3.stop();
          }
        }
      }, trackPurchaseFailure, this);
    })
    /* eslint-enable no-unused-vars, no-empty-function */

  }, {
    key: 'trackPurchaseLoad',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseLoad() {
      var _ref5, msaId, planId, msaOfferId, _ref6, _ref7, userId, cart, plan, msaOffer;

      return _regenerator2.default.wrap(function trackPurchaseLoad$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _effects.select)(getPurchaseFormValues);

            case 2:
              _ref5 = _context4.sent;
              msaId = _ref5.msaId;
              planId = _ref5.planId;
              msaOfferId = _ref5.msaOfferId;
              _context4.next = 8;
              return (0, _effects.all)([(0, _effects.select)(_selectors.userId), (0, _effects.select)(_cart.selectCart), (0, _effects.select)(_bound.planById.data, planId), (0, _effects.select)(_bound.msaOfferById.data, msaOfferId)]);

            case 8:
              _ref6 = _context4.sent;
              _ref7 = (0, _slicedToArray3.default)(_ref6, 4);
              userId = _ref7[0];
              cart = _ref7[1];
              plan = _ref7[2];
              msaOffer = _ref7[3];
              _context4.next = 16;
              return (0, _effects.all)([(0, _effects.spawn)(_multitrack.ec, 'Purchase - Start', {
                plan_id: planId,
                plan_code: plan && plan.plan_code,
                promotion_alias: msaOffer && msaOffer.promotion_alias
              }), (0, _effects.spawn)(_GoogleAnalytics.GoogleAnalytics.sendPageView, '/signup/v2/membership/start'), (0, _effects.spawn)(_GoogleTagManager.trackGoogleTagManagerEvent, {
                event: 'view_cart',
                msaId: msaId,
                userId: userId,
                planId: planId,
                planName: plan && plan.name,
                offerName: msaOffer && msaOffer.offer_name,
                msaOfferId: msaOfferId,
                price: cart.subTotal
              })]);

            case 16:
            case 'end':
              return _context4.stop();
          }
        }
      }, trackPurchaseLoad, this);
    })
  }, {
    key: 'trackPurchaseSuccess',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseSuccess(result) {
      var _ref8, msaId, planId, msaOfferId, giftCode, _ref9, _ref10, plan, msaOffer, gtmDataObject, userId, msaAlias, calls;

      return _regenerator2.default.wrap(function trackPurchaseSuccess$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return (0, _effects.select)(getPurchaseFormValues);

            case 2:
              _ref8 = _context5.sent;
              msaId = _ref8.msaId;
              planId = _ref8.planId;
              msaOfferId = _ref8.msaOfferId;
              giftCode = _ref8.giftCode;
              _context5.next = 9;
              return (0, _effects.all)([(0, _effects.select)(_bound.planById.data, planId), (0, _effects.select)(_bound.msaOfferById.data, msaOfferId)]);

            case 9:
              _ref9 = _context5.sent;
              _ref10 = (0, _slicedToArray3.default)(_ref9, 2);
              plan = _ref10[0];
              msaOffer = _ref10[1];
              gtmDataObject = (0, _keys2.default)(GTM_RESULT_MAPPING).filter(function (gtmKey) {
                return result[GTM_RESULT_MAPPING[gtmKey]];
              }).reduce(function (data, gtmKey) {
                return (0, _assign2.default)(data, (0, _defineProperty3.default)({}, gtmKey, gtmKey === 'currency' ? result[GTM_RESULT_MAPPING[gtmKey]].toUpperCase() : result[GTM_RESULT_MAPPING[gtmKey]]));
              }, { event: 'successful_purchase' });
              _context5.next = 16;
              return (0, _effects.select)(_selectors.userId);

            case 16:
              userId = _context5.sent;
              msaAlias = (0, _msas.msaIdToAlias)(result.msa_id);
              calls = [(0, _effects.call)(_GoogleTagManager.trackGoogleTagManagerEvent, (0, _extends3.default)({}, gtmDataObject, {
                userId: userId,
                msaName: msaAlias
              })), (0, _effects.call)(_GoogleAnalytics.GoogleAnalytics.sendPageView, '/signup/v2/membership/purchase', (0, _defineProperty3.default)({}, _GoogleAnalytics.dimensions.USER_TYPE, 'registered')), (0, _effects.call)(_multitrack.ec, 'Purchase - Complete', {
                plan_id: planId,
                plan_code: plan && plan.plan_code,
                promotion_alias: msaOffer && msaOffer.promotion_alias,
                gift_code: giftCode,
                success: true,
                msa_id: msaId
              }), (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'successful_subscription_purchase'), (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'successful_overall_purchase')];
              _context5.next = 21;
              return (0, _effects.all)(calls);

            case 21:
            case 'end':
              return _context5.stop();
          }
        }
      }, trackPurchaseSuccess, this);
    })

    /* eslint-disable no-unused-vars, no-empty-function */

  }, {
    key: 'trackSignupFailure',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackSignupFailure(encodedId) {
      return _regenerator2.default.wrap(function trackSignupFailure$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
            case 'end':
              return _context6.stop();
          }
        }
      }, trackSignupFailure, this);
    })
  }, {
    key: 'trackSignupLoad',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackSignupLoad(params) {
      return _regenerator2.default.wrap(function trackSignupLoad$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
            case 'end':
              return _context7.stop();
          }
        }
      }, trackSignupLoad, this);
    })
  }, {
    key: 'trackSignupSuccess',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackSignupSuccess(encodedId) {
      return _regenerator2.default.wrap(function trackSignupSuccess$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
            case 'end':
              return _context8.stop();
          }
        }
      }, trackSignupSuccess, this);
    })
    /* eslint-enable no-unused-vars, no-empty-function */

  }]);
  return BaseProduct;
}();

BaseProduct.validator = _Validator.Validator;
BaseProduct.signupValidator = _BaseSignupValidator.baseSignupValidator;

BaseProduct.errorMessager = function (err) {
  return _ApiError.ApiError.messageForDisplay([err], _ApiError.ApiError.billingErrorReducer);
};